<template>
  <div :class="`footers ${isMobile ? 'footers-mobile' : ''}`">
    <div class="box">
      <div class="title">
        <img src="@/images/logo.png" alt="logo" />
        <div class="subtitle">
          <span>无线照明NO.1，国内室内物联控制专家，</span>
          <span>专注产业带IoT智能升级服务</span>
        </div>
      </div>
      <div class="contact">
        <span class="tit">联系我们</span>
        <img
          class="map"
          src="https://restapi.amap.com/v3/staticmap?location=113.21315,22.610341&zoom=15&size=1024*250&markers=mid,,A:113.21215,22.610441&scale=2&key=1d7cbd47e7fe7ae6d2f295669d638295"
          alt="map"
        />
        <div class="info">
          <!-- <h2>中山乐式物联科技有限公司</h2> -->
        </div>
        <div class="info">
          <div class="con">
            <div class="tit">联系邮箱</div>
            <div class="right">
              <div class="desc">
                <div class="t">业务咨询</div>
                <div class="d">xucm@lelight.cn</div>
              </div>
              <div class="desc">
                <div class="t">技术支持</div>
                <div class="d">hobert@lelight.cn</div>
              </div>
            </div>
          </div>
          <div class="con">
            <div class="tit">联系电话</div>
            <div class="right">
              <div class="desc">
                <div class="t">业务咨询</div>
                <div class="d">400-1588-162</div>
              </div>
              <div class="desc">
                <div class="t">技术支持</div>
                <div class="d">400-1588-162</div>
              </div>
            </div>
          </div>
          <div class="con">
            <div class="tit">公司地址</div>
            <div class="right">
              <div class="desc">
                <div class="d">广东省中山市古镇镇东兴东路33号天宏智慧产业园6栋7层</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="copyright" v-if="!isMobile">
        <p>@2010-{{ currYear }} 中山市乐式物联科技有限公司 Zhongshan Lelight Technology Co.,ltd.<a style="color: #409eff" href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备15091468号</a></p>
        <p>Copyright @{{ currYear }} Lelight All rights reserved</p>
      </div>
      <div class="copyright" v-if="isMobile">
        <p>@2010-{{ currYear }} 中山市乐式物联科技有限公司</p>
        <p>Zhongshan Lelight Technology Co.,ltd.</p>
        <p><a style="color: #409eff" href="https://beian.miit.gov.cn/#/Integrated/index">粤ICP备15091468号</a></p>
        <p>Copyright @{{ currYear }} Lelight All rights reserved</p>
      </div>
    </div>
  </div>
</template>

<script>
import { _isMobile } from '@/utils/config';

export default {
  name: 'footers',
  components: {},
  data() {
    return {
      isMobile: _isMobile(),
      currYear: new Date().getFullYear(),
      infos: [
        {
          title: '了解乐式',
          lists: [
            { zh: { tit: '关于我们' }, url: '#' },
            { zh: { tit: '关于我们' }, url: '#' },
            { zh: { tit: '最新动态' }, url: '#' },
            { zh: { tit: '加入我们' }, url: '#' },
            { zh: { tit: '安全中心' }, url: '#' },
          ],
        },
        {
          title: '帮助中心',
          lists: [
            { zh: { tit: '教程说明' }, url: '#' },
            { zh: { tit: '文档中心' }, url: '/help/document' },
            { zh: { tit: '常见问题' }, url: '#' },
          ],
        },
        {
          title: '最新活动',
          lists: [
            { zh: { tit: '语音接入限时免费' }, url: '#' },
            { zh: { tit: '生态伙伴招募' }, url: '#' },
            { zh: { tit: '渠道合作招募' }, url: '#' },
          ],
        },
        {
          title: '法律政策',
          lists: [
            { zh: { tit: '法律声明' }, url: '#' },
            { zh: { tit: '隐私政策' }, url: '#' },
          ],
        },
      ],
      contact: {
        tel: '0760-28817995',
        cooperation: 'marketing@tuya.com',
        mail: 'lelight@.light.cn',
        address: '...',
      },
      qr_code: [
        { src: require('@/images/qr_code.jpg'), name: 'le+Pro' },
        { src: require('@/images/qr_code.jpg'), name: '乐智光' },
        { src: require('@/images/qr_code.jpg'), name: 'le+PLUS' },
      ],
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import './index.less';
</style>
